"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useCHUILanguageSupportContext = exports.useCHUIAbrRegionContext = exports.useCHUITermsContext = exports.useCHUITextSizeContext = exports.useCHUIOldAbrLanguageContext = exports.useCHUIAbrLanguageContext = exports.useCHUILanguageContext = exports.useCHUIUserSelectedLanguageContext = exports.useCHUIDarkModeActionsContext = exports.useCHUIDarkModeContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DarkModeContext = /*#__PURE__*/(0, _react.createContext)(false);
var TermsContext = /*#__PURE__*/(0, _react.createContext)(false);
var UserSelectedLanguageContext = /*#__PURE__*/(0, _react.createContext)(false);
var LanguageContext = /*#__PURE__*/(0, _react.createContext)("English (United Kingdom)");
var AbrLanguageContext = /*#__PURE__*/(0, _react.createContext)("en");
var OldAbrLanguageContext = /*#__PURE__*/(0, _react.createContext)("en");
var TextSizeContext = /*#__PURE__*/(0, _react.createContext)("Regular");
var LanguageSupportContext = /*#__PURE__*/(0, _react.createContext)({
  "s2t": null,
  "t2s": null
});
var AbrRegionContext = /*#__PURE__*/(0, _react.createContext)("en-GB");

var useCHUIDarkModeContext = function useCHUIDarkModeContext() {
  return (0, _react.useContext)(DarkModeContext);
};

exports.useCHUIDarkModeContext = useCHUIDarkModeContext;

var useCHUIDarkModeActionsContext = function useCHUIDarkModeActionsContext() {
  return (0, _react.useContext)(DarkModeContext);
};

exports.useCHUIDarkModeActionsContext = useCHUIDarkModeActionsContext;

var useCHUIUserSelectedLanguageContext = function useCHUIUserSelectedLanguageContext() {
  return (0, _react.useContext)(UserSelectedLanguageContext);
};

exports.useCHUIUserSelectedLanguageContext = useCHUIUserSelectedLanguageContext;

var useCHUILanguageContext = function useCHUILanguageContext() {
  return (0, _react.useContext)(LanguageContext);
};

exports.useCHUILanguageContext = useCHUILanguageContext;

var useCHUIAbrLanguageContext = function useCHUIAbrLanguageContext() {
  return (0, _react.useContext)(AbrLanguageContext);
};

exports.useCHUIAbrLanguageContext = useCHUIAbrLanguageContext;

var useCHUIOldAbrLanguageContext = function useCHUIOldAbrLanguageContext() {
  return (0, _react.useContext)(OldAbrLanguageContext);
};

exports.useCHUIOldAbrLanguageContext = useCHUIOldAbrLanguageContext;

var useCHUITextSizeContext = function useCHUITextSizeContext() {
  return (0, _react.useContext)(TextSizeContext);
};

exports.useCHUITextSizeContext = useCHUITextSizeContext;

var useCHUITermsContext = function useCHUITermsContext() {
  return (0, _react.useContext)(TermsContext);
};

exports.useCHUITermsContext = useCHUITermsContext;

var useCHUIAbrRegionContext = function useCHUIAbrRegionContext() {
  return (0, _react.useContext)(AbrRegionContext);
};

exports.useCHUIAbrRegionContext = useCHUIAbrRegionContext;

var useCHUILanguageSupportContext = function useCHUILanguageSupportContext() {
  return (0, _react.useContext)(LanguageSupportContext);
};

exports.useCHUILanguageSupportContext = useCHUILanguageSupportContext;

var CHUIContextProvider = function CHUIContextProvider(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasAcceptedTerms = _useState2[0],
      setHasAcceptedTerms = _useState2[1];

  var _useState3 = (0, _react.useState)(localStorage.getItem("CHUIDarkMode") === "true" ? true : false),
      _useState4 = _slicedToArray(_useState3, 2),
      prefersDarkMode = _useState4[0],
      setPrefersDarkMode = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      userSelectedLanguage = _useState6[0],
      setUserSelectedLanguage = _useState6[1];

  var _useState7 = (0, _react.useState)("English (UK)"),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedLanguage = _useState8[0],
      setSelectedLanguage = _useState8[1];

  var _useState9 = (0, _react.useState)("en"),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedAbrLanguage = _useState10[0],
      setSelectedAbrLanguage = _useState10[1];

  var _useState11 = (0, _react.useState)("en"),
      _useState12 = _slicedToArray(_useState11, 2),
      selectedOldAbrLanguage = _useState12[0],
      setSelectedOldAbrLanguage = _useState12[1];

  var _useState13 = (0, _react.useState)("Regular"),
      _useState14 = _slicedToArray(_useState13, 2),
      selectedTextSize = _useState14[0],
      setSelectedTextSize = _useState14[1];

  var _useState15 = (0, _react.useState)("en-GB"),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedAbrRegion = _useState16[0],
      setSelectedAbrRegion = _useState16[1];

  var _useState17 = (0, _react.useState)({
    "s2t": null,
    "t2s": null
  }),
      _useState18 = _slicedToArray(_useState17, 2),
      languageSupport = _useState18[0],
      setLanguageSupport = _useState18[1];

  return /*#__PURE__*/_react.default.createElement(UserSelectedLanguageContext.Provider, {
    value: {
      userSelectedLanguage: userSelectedLanguage,
      setUserSelectedLanguage: setUserSelectedLanguage
    }
  }, /*#__PURE__*/_react.default.createElement(TextSizeContext.Provider, {
    value: {
      selectedTextSize: selectedTextSize,
      setSelectedTextSize: setSelectedTextSize
    }
  }, /*#__PURE__*/_react.default.createElement(LanguageContext.Provider, {
    value: {
      selectedLanguage: selectedLanguage,
      setSelectedLanguage: setSelectedLanguage
    }
  }, /*#__PURE__*/_react.default.createElement(AbrLanguageContext.Provider, {
    value: {
      selectedAbrLanguage: selectedAbrLanguage,
      setSelectedAbrLanguage: setSelectedAbrLanguage
    }
  }, /*#__PURE__*/_react.default.createElement(OldAbrLanguageContext.Provider, {
    value: {
      selectedOldAbrLanguage: selectedOldAbrLanguage,
      setSelectedOldAbrLanguage: setSelectedOldAbrLanguage
    }
  }, /*#__PURE__*/_react.default.createElement(DarkModeContext.Provider, {
    value: {
      prefersDarkMode: prefersDarkMode,
      setPrefersDarkMode: setPrefersDarkMode
    }
  }, /*#__PURE__*/_react.default.createElement(TermsContext.Provider, {
    value: {
      hasAcceptedTerms: hasAcceptedTerms,
      setHasAcceptedTerms: setHasAcceptedTerms
    }
  }, /*#__PURE__*/_react.default.createElement(LanguageSupportContext.Provider, {
    value: {
      languageSupport: languageSupport,
      setLanguageSupport: setLanguageSupport
    }
  }, /*#__PURE__*/_react.default.createElement(AbrRegionContext.Provider, {
    value: {
      selectedAbrRegion: selectedAbrRegion,
      setSelectedAbrRegion: setSelectedAbrRegion
    }
  }, props.children)))))))));
};

var _default = CHUIContextProvider;
exports.default = _default;